<template>
  <van-popover v-model:show="isPop">
    <div class="adminControl">
      <div class="title">{{ userinfo.serial }} {{ userinfo.userName }}</div>
      <div class="btns">
        <div v-if="userinfo.isAdmin" class="btn" @click="cancelSerialBind">
          <van-icon name="close" />
          取消企业号绑定
        </div>
        <div class="btn" @click="onLogout">
          <van-icon name="stop-circle-o" />
          退出登录
        </div>
      </div>
    </div>
    <template #reference>
      <van-icon name="link-o" />
    </template>
  </van-popover>
</template>

<script setup lang="ts">
import { useStore } from "@/store";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { showConfirmDialog } from "vant";
import { logout } from "@/hooks/useLogin";
import { ApiCancelSerialBind, ApiUserExit } from "@/api";
import { isWeComMobile } from "@/utils";
const isPop = ref(false);
const store = useStore();

const { userinfo } = storeToRefs(store);

const cancelSerialBind = async () => {
  await showConfirmDialog({ title: "取消企业号绑定", message: `确定取消该企业微信与企业号${userinfo.value.serial}的绑定？` });
  console.log("取消企业号绑定");
  await ApiCancelSerialBind();
  logout();
};
const onLogout = async () => {
  await showConfirmDialog({ title: "退出登录", message: "确定退出当前账号？" });
  console.log("退出登录");
  await ApiUserExit({ type: isWeComMobile() ? 2 : 1 });
  logout();
};

store.setNowUserinfo();
</script>
<style lang="less" scoped>
.adminControl {
  @pad: 15px;
  display: flex;
  flex-direction: column;
  font-size: 32px;
  .title {
    border-bottom: 1px solid #ccc;
    padding: @pad;
  }
  .btns {
    padding: @pad;
  }
  .btn {
    @size: 26px;
    font-size: @size;
    padding-bottom: 15px;
    &:last-child {
      padding-bottom: 0;
    }
    .van-icon {
      font-size: @size + 2;
    }
  }
}
</style>
